module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "treatments",
    attrs: {
      "id": "treatments"
    }
  }, [_c('div', {
    staticClass: "treatments__title"
  }, [_vm._v("- Treatments -  ")]), _c('div', {
    staticClass: "treatments__container"
  }, [_c('swiper', {
    staticClass: "treatments__swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.acf.treatments.slides), function(slide, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "treatments__slide"
    }, [_c('div', {
      staticClass: "treatments__col"
    }, [_c('img', {
      staticClass: "treatments__image",
      attrs: {
        "src": slide.image,
        "alt": "treatments"
      }
    })]), _c('div', {
      staticClass: "treatments__col"
    }, [_c('div', {
      staticClass: "treatments__content",
      domProps: {
        "innerHTML": _vm._s(slide.content)
      }
    })])])
  }), _c('div', {
    staticClass: "treatments__next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1), _c('div', {
    staticClass: "treatments__prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1), _c('div', {
    staticClass: "treatments__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _c('div', {
    staticClass: "treatments__arrow",
    on: {
      "click": function($event) {
        _vm.moveTo(6)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383340d9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sections/treatments/treatments.pug
// module id = 535
// module chunks = 1